import { vars } from '@etg/wings';
import { css } from '@eti/styles';
import variants from '../../utils/variants';
const backgroundColorsByVariant = {
  [variants.CONFIRMATION]: vars.colors.signal.positive.background,
  [variants.CRITICAL]: vars.colors.signal.critical.background,
  [variants.INFORMATION]: vars.colors.signal.information.background,
  [variants.WARNING]: vars.colors.signal.caution.background
};
const defaultBorderColorsByVariant = {
  [variants.CONFIRMATION]: vars.colors.signal.positive.foreground,
  [variants.CRITICAL]: vars.colors.signal.critical.foreground,
  [variants.INFORMATION]: vars.colors.signal.information.foreground,
  [variants.WARNING]: vars.colors.signal.caution.foreground
};
export const getBackgroundColor = (variant = variants.INFORMATION) => css`
  background-color: ${backgroundColorsByVariant[variant]};
`;
export const getBorderColor = (variant = variants.INFORMATION, isRevolut) => css`
  border: 1px solid
    ${isRevolut ? backgroundColorsByVariant[variant] : defaultBorderColorsByVariant[variant]};
`;
//# sourceMappingURL=notificationStyles.js.map